import {
  CalculatorOperations,
  getRoundedCakePortionsMin,
  getRoundedCakePortionsMax
} from '../../../../helpers/cake'
import { roundedCakeValidator } from './RoundedCakeValidator'

interface Result {
  MIN: number
  MAX: number
}

interface RoundedPortionsCalculatorActions {
  height: string
  d: string
  errors: string[]
  result: Result | null
  calculate: () => void
}

export const initialRoundedPortionsReducer: RoundedPortionsCalculatorActions = {
  height: '',
  d: '',
  errors: [],
  result: null,
  calculate: (): void => {
    // INITIAL VALUE
  }
}

const updateValidationErrors = (
  errors: string[],
  state: RoundedPortionsCalculatorActions
): RoundedPortionsCalculatorActions => ({
  ...state,
  errors,
  result: null
})

const calculateResult = (
  state: RoundedPortionsCalculatorActions
): RoundedPortionsCalculatorActions => ({
  ...state,
  result: {
    MIN: Math.round(
      getRoundedCakePortionsMin(parseFloat(state.height), parseFloat(state.d))
    ),
    MAX: Math.round(
      getRoundedCakePortionsMax(parseFloat(state.height), parseFloat(state.d))
    )
  },
  errors: []
})

export const CALCULATE_RESULT = 'CALCULATE_RESULT'
export const UPDATE_ROUNDED_PORTIONS_CALC_DATA =
  'UPDATE_ROUNDED_PORTIONS_CALC_DATA'

export enum RoundedPortionsReducerActionName {
  CALCULATE_RESULT = 'CALCULATE_RESULT',
  UPDATE_ROUNDED_PORTIONS_CALC_DATA = 'UPDATE_ROUNDED_PORTIONS_CALC_DATA'
}

export type RoundedPortionsReducerActions =
  | {
      type: RoundedPortionsReducerActionName.CALCULATE_RESULT
    }
  | {
      type: RoundedPortionsReducerActionName.UPDATE_ROUNDED_PORTIONS_CALC_DATA
      data: CalculatorOperations
    }

const calculate = (
  state: RoundedPortionsCalculatorActions
): RoundedPortionsCalculatorActions => {
  const validationErrors = roundedCakeValidator(state.height, state.d)
  if (validationErrors.length > 0) {
    return updateValidationErrors(validationErrors, state)
  }
  return calculateResult(state)
}

const updateCalcData = (
  data: CalculatorOperations,
  state: RoundedPortionsCalculatorActions
): RoundedPortionsCalculatorActions => ({
  ...state,
  [data.fieldName]: data.fieldValue
})

export const roundedCakeReducer = (
  state: RoundedPortionsCalculatorActions,
  action: RoundedPortionsReducerActions
): RoundedPortionsCalculatorActions => {
  switch (action.type) {
    case RoundedPortionsReducerActionName.CALCULATE_RESULT:
      return calculate(state)
    case RoundedPortionsReducerActionName.UPDATE_ROUNDED_PORTIONS_CALC_DATA:
      return updateCalcData(action.data, state)
    default:
      return state
  }
}
